import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [17,[2],[3]],
		"/(app)/(wizard)/account/account-access": [18,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-activity": [19,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type": [20,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/joint": [21,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/retirement/account": [22,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/retirement/beneficiary-inherited": [23,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/retirement/decedent-name": [24,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/retirement/individual": [25,[2,4,5],[3]],
		"/(app)/(wizard)/account/account-type/select": [26,[2,4,5],[3]],
		"/(app)/(wizard)/account/add-beneficiaries": [27,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/beneficiaries": [28,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/beneficiary-address": [29,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/beneficiary-details": [30,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/beneficiary-name": [31,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/trust-beneficiary": [32,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/add-beneficiaries/type-of-beneficiary": [33,[2,4,5,6],[3]],
		"/(app)/(wizard)/account/additional-information": [34,[2,4,5],[3]],
		"/(app)/(wizard)/account/additional-information/estate-percentage-allocation": [35,[2,4,5],[3]],
		"/(app)/(wizard)/account/additional-information/secondary-owner": [36,[2,4,5],[3]],
		"/(app)/(wizard)/account/trading-experience": [37,[2,4,5,7],[3]],
		"/(app)/(wizard)/account/trading-experience/financial-information": [38,[2,4,5,7],[3]],
		"/(app)/(wizard)/account/trading-experience/instruments-knowledge": [39,[2,4,5,7],[3]],
		"/(app)/(wizard)/account/trading-experience/trading-objective": [40,[2,4,5,7],[3]],
		"/(app)/(wizard)/account/trading-method": [41,[2,4,5],[3]],
		"/(app)/(wizard)/business/affiliation": [42,[2,4,8],[3]],
		"/(app)/(wizard)/business/beneficial-owners": [43,[2,4,8],[3]],
		"/(app)/(wizard)/business/contact": [44,[2,4,8],[3]],
		"/(app)/(wizard)/business/relationship": [45,[2,4,8],[3]],
		"/(session)/confirmation": [96,[16]],
		"/(app)/(wizard)/documents/documents-upload": [46,[2,4,9,10],[3]],
		"/(app)/(wizard)/documents/documents-upload/address-opt-out": [47,[2,4,9,10],[3]],
		"/(app)/(wizard)/documents/documents-upload/confirm": [48,[2,4,9,10],[3]],
		"/(app)/(wizard)/documents/documents-upload/upload": [49,[2,4,9,10],[3]],
		"/(app)/(wizard)/documents/important-documents": [50,[2,4,9],[3]],
		"/(app)/done/auto-approved": [91,[2,15],[3]],
		"/(app)/done/documents-required": [92,[2,15],[3]],
		"/(app)/done/joint-continuation": [93,[2,15],[3]],
		"/(app)/done/needs-review": [94,[2,15],[3]],
		"/(app)/error": [95,[2],[3]],
		"/(session)/joint-continuation-signup": [97,[16]],
		"/(session)/joint-continuation-signup/success": [98,[16]],
		"/(session)/login": [99,[16]],
		"/(app)/(wizard)/personal-info/affiliation-information": [51,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/affiliation-information/industry-affiliation": [52,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/affiliation-information/institutional-assets-affiliation": [53,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/affiliation-information/investment-advisor-affiliation": [54,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/affiliation-information/political-affiliation": [55,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/affiliation-information/public-company-affiliation": [56,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status": [57,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status/citizenship": [58,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status/documents-to-prepare": [59,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status/foreign-citizenship": [60,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status/residency": [61,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/citizenship-status/visa": [62,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information": [63,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/mailing-address": [64,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/name": [65,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/phone-number": [66,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/physical-address": [67,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/same-address": [68,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/contact-information/sms-notifications": [69,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/employment-information": [70,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/employment-information/employment-status": [71,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/employment-information/job-details": [72,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/tax-information": [73,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/tax-information/birth-date": [74,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/tax-information/family": [75,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/tax-information/subject-to-tax-withholding": [76,[2,4,11],[3]],
		"/(app)/(wizard)/personal-info/tax-information/tax-number": [77,[2,4,11],[3]],
		"/(app)/(wizard)/review": [78,[2,4],[3]],
		"/(app)/(wizard)/security/confirm-identity": [79,[2,4,12],[3]],
		"/(app)/(wizard)/security/security-question": [80,[2,4,12],[3]],
		"/(app)/(wizard)/security/trusted-contact": [81,[2,4,12,13],[3]],
		"/(app)/(wizard)/security/trusted-contact/add-trusted-contact": [82,[2,4,12,13],[3]],
		"/(app)/(wizard)/security/trusted-contact/address": [83,[2,4,12,13],[3]],
		"/(app)/(wizard)/security/trusted-contact/contact-info": [84,[2,4,12,13],[3]],
		"/(app)/(wizard)/security/trusted-contact/personal-info": [85,[2,4,12,13],[3]],
		"/(app)/(wizard)/security/two-factor-auth": [86,[2,4,12,14],[3]],
		"/(app)/(wizard)/security/two-factor-auth/method-selection": [87,[2,4,12,14],[3]],
		"/(app)/(wizard)/security/two-factor-auth/setup": [88,[2,4,12,14],[3]],
		"/(app)/(wizard)/security/two-factor-auth/sms": [89,[2,4,12,14],[3]],
		"/(session)/signup": [100,[16]],
		"/(session)/signup/account-type": [101,[16]],
		"/(app)/[...catchAll]": [90,[2],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';